/**
 * @Author:
 * @Description:
 * @DateTime: Created in 14:37 2019-08-24
 */
import routerInstance from "../router/routerInstance";


export default class RouteUtils {
	/**
	 * 路由条状
	 * @param ctx
	 * @param {string} name
	 * @param {object} query
	 */
	static goTo (path: string, query: any = {}, params:any = {}) {
		routerInstance.push({
			path,
			query,
            params,
            
		})
	}

	static goToWidthCache (path: string, query: any = {}, params:any = {}) {
		RouteUtils.goTo(path, query, {...params, widthCache: true})
	}

	/**
	 * 路由返回
	 * @param ctx
	 */
	static goBack (number = -1) {
		routerInstance.go(number)
	}

}
